export default __webpack_public_path__ + "static/media/product_img_nav.f17c2143.png";